import platformLogoCompactDarkUrl from "../../assets/logos/logo-x3/logo-compact-dark.png";
import platformLogoCompactLightUrl from "../../assets/logos/logo-x3/logo-compact-light.png";
import platformLogoHorizontalDarkUrl from "../../assets/logos/logo-x3/logo-horizontal-dark.png";
import platformLogoHorizontalLightUrl from "../../assets/logos/logo-x3/logo-horizontal-light.png";
import platformLogoIconUrl from "../../assets/logos/logo-x3/logo-icon.png";
import rafikiProfileUrl from "../../assets/logos/rafiki-profile.png";

export const PLATFORM_LOGO_ICON_URL = platformLogoIconUrl;
/** Profile photo for the Rafiki in-app assistant (launcher button + chat avatar). */
export const RAFIKI_PROFILE_URL = rafikiProfileUrl;
export const PLATFORM_LOGO_COMPACT_LIGHT_URL = platformLogoCompactLightUrl;
export const PLATFORM_LOGO_COMPACT_DARK_URL = platformLogoCompactDarkUrl;
export const PLATFORM_LOGO_HORIZONTAL_LIGHT_URL = platformLogoHorizontalLightUrl;
export const PLATFORM_LOGO_HORIZONTAL_DARK_URL = platformLogoHorizontalDarkUrl;
